/* Preflight the theme's existing purchase handlers; preserve Fundpop and form data. */
(() => {
  if (window.ofpCartRoutingInstalled) return;
  const configNode = document.getElementById('OFP-Cart-Routing');
  if (!configNode) return;
  window.ofpCartRoutingInstalled = true;
  const config = JSON.parse(configNode.textContent);
  const ofpURL = config.cartURL + '?view=official-flower-project';
  const approvedForms = new WeakSet();
  const approvedLinks = new WeakSet();
  const approvedChanges = new WeakSet();
  let checking = false;

  async function state() {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 10000);
    let response;
    try {
      response = await fetch(config.cartURL + '?view=ofp-state&_=' + Date.now(), {
        cache: 'no-store', credentials: 'same-origin', headers: {Accept: 'text/html'}, signal: controller.signal
      });
    } finally { clearTimeout(timer); }
    if (!response.ok) throw new Error('カートを確認できませんでした。再読み込みしてからお試しください。');
    const result = await response.json();
    if (result.version !== 1 || !Array.isArray(result.items) || result.items.some(item =>
      !item.product_id || typeof item.ofp !== 'boolean' || typeof item.closed !== 'boolean')) {
      throw new Error('カートを確認できませんでした。再読み込みしてからお試しください。');
    }
    return result.items;
  }
  // Only cart-wide fields owned by the normal flower cart; never line properties or app data.
  const regularAttributeKeys = ['配送希望日', '配送希望時間帯', '回収希望日', '回収希望時間・備考', '回収について', '立札内容'];
  async function clearRegularAttributes() {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 10000);
    try {
      const response = await fetch(config.cartURL + '/update.js', {
        method: 'POST', credentials: 'same-origin', signal: controller.signal,
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({attributes: Object.fromEntries(regularAttributeKeys.map(key => [key, '']))})
      });
      if (!response.ok) throw new Error('attribute cleanup failed');
      const cart = await response.json();
      if (!cart.attributes || typeof cart.attributes !== 'object' || Array.isArray(cart.attributes) ||
          regularAttributeKeys.some(key => cart.attributes[key] != null && cart.attributes[key] !== '')) {
        throw new Error('attribute cleanup not confirmed');
      }
    } finally { clearTimeout(timer); }
  }
  function readyCheckout(scope = document) {
    scope.querySelectorAll('[data-ofp-checkout-allowed="true"]').forEach(button => { button.disabled = false; });
  }
  readyCheckout();
  document.addEventListener('shopify:section:load', event => readyCheckout(event.target));
  function tell(message, scope = document.querySelector('main') || document.body, href = config.cartURL) {
    let notice = scope.querySelector('[data-ofp-routing-notice]');
    if (!notice) {
      notice = document.createElement('div');
      notice.dataset.ofpRoutingNotice = '';
      notice.setAttribute('role', 'alert');
      notice.setAttribute('tabindex', '-1');
      notice.style.cssText = 'padding:16px;margin:16px 0;border:1px solid currentColor;';
      scope.prepend(notice);
    }
    const text = document.createElement('p');
    text.textContent = message;
    const link = document.createElement('a');
    link.href = href;
    link.textContent = 'カートを確認する';
    notice.replaceChildren(text, link);
    notice.focus();
  }
  function incompatible(items, ofp, productID) {
    if (items.some(item => item.ofp !== ofp)) {
      return '通常商品とOFPは別々にお手続きください。現在のカートの商品はそのまま残しています。';
    }
    if (ofp && items.some(item => String(item.product_id) !== String(productID))) {
      return 'プロジェクトごとにお手続きください。現在のカートの参加プランはそのまま残しています。';
    }
    return '';
  }
  function stop(event) { event.preventDefault(); event.stopImmediatePropagation(); }
  function path(url) { return new URL(url, location.href).pathname.replace(/\/$/, ''); }

  window.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (approvedForms.delete(form)) return;
    const isAdd = path(form.action).endsWith('/cart/add');
    const isCheckout = event.submitter?.name === 'checkout';
    if (!isAdd && !isCheckout) return;
    stop(event);
    if (checking || form.dataset.ofpClosed === 'true' || event.submitter?.disabled) return;
    if (isAdd && !form.reportValidity()) return;
    checking = true;
    const submitter = event.submitter;
    const ofp = form.dataset.ofpForm === 'true';
    const productID = form.querySelector('[name="properties[_ofp_product_id]"]')?.value;
    try {
      const items = await state();
      const hasOFP = items.some(item => item.ofp);
      if (isAdd) {
        const message = incompatible(items, ofp, productID);
        if (message) { tell(message, form, hasOFP ? ofpURL : config.cartURL); return; }
      } else if (hasOFP) {
        const invalid = items.some(item => !item.ofp || item.closed) || new Set(items.map(item => item.product_id)).size > 1;
        if (invalid || !form.matches('[data-ofp-cart-form]')) { location.assign(ofpURL); return; }
        if (submitter?.dataset.ofpCheckoutAllowed !== 'true') return;
        await clearRegularAttributes();
        // Recheck after the update, in case another tab changed cart membership.
        const latestItems = await state();
        if (!latestItems.length || latestItems.some(item => !item.ofp || item.closed) ||
            new Set(latestItems.map(item => item.product_id)).size !== 1 ||
            String(latestItems[0].product_id) !== String(items[0].product_id)) {
          tell('カートの内容が変わりました。再読み込みしてご確認ください。', form, ofpURL);
          return;
        }
      } else if (isCheckout && form.matches('[data-ofp-cart-form]')) {
        tell('OFPの参加プランがありません。カートを再読み込みしてください。', form, ofpURL);
        return;
      }
      if (!form.isConnected || form.dataset.ofpClosed === 'true' || submitter?.disabled || (submitter && !(submitter.isConnected && submitter.form === form))) return;
      form.querySelector('[data-ofp-routing-notice]')?.remove();
      approvedForms.add(form);
      try { form.requestSubmit(submitter || undefined); }
      finally { approvedForms.delete(form); }
      // Native Dawn marks the submit button busy synchronously and clears it on completion.
      if (isAdd && submitter?.getAttribute('aria-disabled') === 'true') {
        await new Promise(resolve => {
          const observer = new MutationObserver(() => {
            if (submitter.getAttribute('aria-disabled') !== 'true' || !submitter.classList.contains('loading')) finish();
          });
          const timer = setTimeout(finish, 30000);
          function finish() { clearTimeout(timer); observer.disconnect(); resolve(); }
          observer.observe(submitter, {attributes: true});
        });
      }
    } catch (error) {
      tell('カートを確認できませんでした。再読み込みしてからお試しください。', form);
    } finally { checking = false; }
  }, true);

  window.addEventListener('click', async event => {
    const link = event.target.closest?.('a[href]');
    if (!link || approvedLinks.delete(link) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || ![path(config.cartURL), path(config.cartURL).replace(/\/cart$/, '/checkout')].includes(path(url))) return;
    stop(event);
    try {
      const items = await state();
      if (items.some(item => item.ofp) || (config.ofpPage && items.length === 0)) { location.assign(ofpURL); return; }
      // A normal-only cart must remain reachable from OFP notices and stale header links.
      if (config.ofpPage || url.searchParams.get('view') === 'official-flower-project') { location.assign(config.cartURL); return; }
      approvedLinks.add(link);
      try { link.click(); } finally { approvedLinks.delete(link); }
    } catch (error) { tell('カートを確認できませんでした。再読み込みしてからお試しください。'); }
  }, true);

  // These controls are currently disabled in card-product, but keep the guard if enabled later.
  window.addEventListener('change', async event => {
    const input = event.target;
    if (!input.matches?.('input[type="number"]') || !input.closest('quick-add-bulk, quick-order-list')) return;
    if (approvedChanges.delete(input)) return;
    stop(event);
    if (checking) { input.value = input.defaultValue; return; }
    checking = true;
    try {
      const items = await state();
      if (items.some(item => item.ofp)) {
        input.value = input.defaultValue;
        tell(incompatible(items, false), input.closest('quick-add-bulk, quick-order-list'), ofpURL);
        return;
      }
      approvedChanges.add(input);
      try { input.dispatchEvent(new Event('change', {bubbles:true})); }
      finally { approvedChanges.delete(input); }
    } catch (error) {
      input.value = input.defaultValue;
      tell('カートを確認できませんでした。再読み込みしてからお試しください。');
    } finally { checking = false; }
  }, true);
})();
